import { success as successStatus } from "~/router/apiResponseStatus";
import urlMixin from "~/mixins/url";

const baseMixin = {
  mixins: [urlMixin],
  data() {
    return {
      statuses: {
        isLoading: false,
        isFirstLoad: true,
        initialLoadState: true,
      },
      loaderCount: this.getRandomNumber(),
      minLoadTime: 900,
      startTime: null,
      minLoadTimer: null
    };
  },
  computed: {
    isLoading() {
      return this.statuses.isLoading;
    },
    isFirstLoad() {
      return this.statuses.isFirstLoad;
    },
    isInitialLoadState() {
      return this.statuses.initialLoadState;
    }
  },
  methods: {
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    handleErrorForRedirect(error, redirectRoute, customMessages = {}) {
      let errorMessage = this.$t(customMessages.default || "request_error_replay");

      if (error.response && error.response.status === 403) {
        errorMessage = this.$t(customMessages[403] || "access_denied");
      }

      this.$toast.error(errorMessage);

      if (redirectRoute) {
        this.$router.push(redirectRoute);
      }
    },
    setInitialLoadState(value) {
      return this.statuses.initialLoadState = value;
    },
    handleShowRequestError(error, redirectRouteData) {
      let errorMessage = this.$t("request_error_replay");

      if (error.response?.status === 403) {
        errorMessage = this.$t("access_denied");
      }

      this.$toast.error(errorMessage);
      this.$router.push({ name: redirectRouteData });
    },
    getRandomNumber(min = 2, max = 5) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    startLoading() {
      this.enabledLoading();
      this.startTime = Date.now();
    },
    finishLoading() {
      this.setInitialLoadState(false);

      const elapsedTime = Date.now() - this.startTime;
      const remainingTime = Math.max(this.minLoadTime - elapsedTime, 0);

      if (remainingTime > 0) {
        setTimeout(() => {
          this.disabledLoading();
          this.disabledFirstLoad();
          this.handleHashAfterDataLoad();
        }, remainingTime);
      } else {
        this.disabledLoading();
        this.disabledFirstLoad();
        this.handleHashAfterDataLoad();

      }
    },

    async loadData(callback, options = { useLoading: true }) {
      if (options.useLoading) {
        this.startLoading();
      }

      try {
        await callback();
      } finally {
        if (options.useLoading) {
          await this.finishLoading();
        } else {
          this.handleHashAfterDataLoad();
        }
      }
    },
    disabledFirstLoad() {
      this.statuses.isFirstLoad = false;
    },
    enabledLoading() {
      this.statuses.isLoading = true;
    },
    disabledLoading() {
      this.statuses.isLoading = false;
    },
    isSuccessStatus(data) {
      return data?.status === successStatus;
    },
    setSubmitErrors(errors, formName) {
      let errorsData = errors.response.data.errors;

      Object.keys(errorsData).forEach((key) => {
        let error = {};
        error[key] = errorsData[key][0];
        this.$refs[formName].setErrors(error);
      });
    }
  }
};

export default baseMixin;
